<template>
  <form
    class=""
    @submit.prevent="customerOtp"
    @paste="handlePaste"
    @input="handleInput"
    @keyup.delete="handleDeletion"
    ref="form"
    v-if="this.microAppsUrlParams.m_code !== 'GPAY'"
  >
    <h1 class="heading-text md:pb-6 pb-2 md:pt-0 pt-8">Enter Otp</h1>
    <p class="secondary-heading-text">a 4- digit OTP will be shared on your provided mobile number for verification</p>
    <div
      class="flex md:gap-8 gap-6 pt-4 md:pt-6 justify-between"
    >
      <input
        type="text"
        class="input input--single input--w-32"
        inputmode="numeric"
        v-model.trim="otp[0]"
        required
        name="1"
        minlength="1"
        maxlength="1"
        tabindex="1"
        @keypress="isNumber"
        autocomplete="off"
        @copy.prevent
        @cut.prevent
        @paste.prevent
      />
      <input
        type="text"
        class="input input--single input--w-32"
        inputmode="numeric"
        v-model.trim="otp[1]"
        required
        name="2"
        minlength="1"
        maxlength="1"
        @keypress="isNumber"
        autocomplete="off"
        @copy.prevent
        @cut.prevent
        @paste.prevent
      />
      <input
        type="text"
        class="input input--single input--w-32"
        inputmode="numeric"
        v-model.trim="otp[2]"
        required
        name="3"
        minlength="1"
        maxlength="1"
        @keypress="isNumber"
        autocomplete="off"
        @copy.prevent
        @cut.prevent
        @paste.prevent
      />
      <input
        type="text"
        class="input input--single input--w-32"
        inputmode="numeric"
        v-model.trim="otp[3]"
        required
        name="4"
        minlength="1"
        maxlength="1"
        @keypress="isNumber"
        autocomplete="off"
        @copy.prevent
        @cut.prevent
        @paste.prevent
      />
    </div>
    <!-- resend-otp -->
    <span class="flex justify-end pt-5 text-gray-600 text-base w-full text-primary">
      <button
        v-if="!timer"
        id="resend-button"
        class="text-primary underline"
        type="button"
        @click="resendOtp"
      >Resend OTP</button>
      <template v-else>
        <span class="cursor-default">Resend OTP in</span>&nbsp;
        <br />
        <span class="text-primary cursor-default">{{ timer }}s</span>
      </template>
    </span>
    <!-- referral-code -->
    <details
      v-if="showReferrerCode"
      class="label text-left pt-4 w-full"
    >
        <summary
          class="flex justify-between cursor-pointer marker-none list-none bg-details-arrow bg-no-repeat focus:outline-none outline-none pb-2"
        >
          <p class="font-myriad text-primary text-base underline">Referral Code</p>
        </summary>
        <input
          type="text"
          class="input text-lg h-16"
          v-model.trim="referrerCode"
        />
    </details>
    <!-- fos-Id -->
    <details
      class="label text-left pt-4 w-full"
    >
        <summary
          class="flex justify-between cursor-pointer marker-none list-none bg-details-arrow bg-no-repeat focus:outline-none outline-none pb-2"
        >
          <p class="font-myriad text-primary text-base underline">FOS ID</p>
        </summary>
        <input
          type="text"
          class="input text-lg h-16"
          v-model.trim="referrerCode"
        />
    </details>
    <fieldset class="text-left md:w-auto w-80 mt-4 flex gap-4" v-if="!tncAccepted">
      <legend></legend>
      <span class="p-px">
        <input type="checkbox" name="tnc" id="tnc" required class="text-primary" />
      </span>
      <label for="tnc">
        I have read, understood and I agree to content of this agreement, and I hereby consent to "Arthashastra EpayLater Financial Private Limited" being appointed as your authorized representative to receive your Credit Information from Experian for the purpose of providing offers on credit products and assessing credit eligibility of the customer ("End Use Purpose"), on month on month basis for  a period of six (6) months. I also agree to
        <a
          href="https://s3.ap-south-1.amazonaws.com/epaylater-marketing/Experian_Terms.pdf"
          target="_blank"
          class="text-primary underline"
        >Experian Terms and Conditions</a>
        &
        <a
          class="text-primary underline"
          :href="tncLink"
          target="_blank"
        >ePayLater Standard Terms and Conditions will be links as earlier</a>.
      </label>
    </fieldset>
    <div class="grid md:pb-0 pb-8">
    <custom-button
      variant="primary"
      class="mt-8 justify-center font-extrabold"
      type="submit"
      arrowAnimation
    >Next</custom-button>
    </div>
  </form>
  <!-- Error POpUp -->
  <transition name="fade">
    <modal @close-modal="false" v-if="errorMessage">
      <div
        class="bg-white px-6 pt-4 pb-6 grid gap-8 justify-items-center w-full rounded-t-2xl text-center"
      >
        <div title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
        <div class="grid gap-6 justify-center justify-items-center w-full">
          <img src="../assets/mandate-failure.svg" alt="Error" width="119" height="115" />
          <div class="grid px-4 gap-4">
            <p class="label-text-headingColor-myriad font-semibold">{{ errorMessage }}</p>
            <p class="label-text-headingColor-myriad">Please contact support team <br/>
              <a class="underline text-primary font-bold"
                @click="supportClicked()"
                href="tel:+918100050505">
                +91-8100050505
              </a>
            </p>
          </div>
        </div>
        <div class="grid w-full">
          <custom-button variant="primary" type="button" @click.prevent="resetErrorMessageAndRedirectToGPay">Back</custom-button>
        </div>
      </div>
    </modal>
  </transition>
  <!-- Spin Loader -->
  <spin-loader :spinLoading="isSpinLoading"/>
</template>
<script>
import { mapGetters } from "vuex";
import CustomButton from "../components/CustomButton.vue";
import SpinLoader from '../components/spinLoader.vue';
import Modal from '../components/Modal.vue';

export default {
  name: "VerifyOtp",
  components: {
    CustomButton,
    SpinLoader,
    Modal
  },
  computed: {
    ...mapGetters(["sessionId", "isReferralFlow", "phone", 'microAppsUrlParams'])
  },
  data() {
    return {
      otp: [],
      isSpinLoading: undefined,
      timer: 30,
      timerInterval: undefined,
      errorMessage: undefined,
      tncLink: undefined,
      tncAccepted: undefined,
      showReferrerCode: undefined,
      referrerCode: undefined,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.isSpinLoading = true;
      const sessionId = this.$route.query?.session;
      if (sessionId) {
        this.$store.commit('SAVE_PHONE', this.$route.query?.phone);
        if (this.isReferralFlow) {
          if (this.$route.query.redirect === 'on-boarding' || this.$route.query.redirect === 'on-boarding-testing') {
            this.$router.push({
              name: "Signup",
            });
          } else if (this.$route.query.redirect === 'suppliers' || this.$route.query.redirect === 'suppliers-testing') {
            this.$router.push({
              name: "Suppliers",
            });
          } else if (this.$route.query.redirect === 'transaction-details' || this.$route.query.redirect === 'transaction-details-testing') {
            this.$router.push({
              name: "Credit Statement Pay Now",
              query: {
                transactionId: this.$route.query.transactionId
              },
            });
          } else if (this.$route.query.redirect === 'transaction-list' || this.$route.query.redirect === 'transaction-list-testing') {
            this.$router.push({
              name: "Credit Statement",
            });
          }
        } else {
          this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_VERIFY_OTP_FAILURE, {
            [this.$mixpanelPayload.ERROR_REASON]: 'isReferralFlow not present'
          });
        }
      } else {
        this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_VERIFY_OTP_FAILURE, {
          [this.$mixpanelPayload.ERROR_REASON]: 'SessionId not present'
        });
      }
      // this.errorMessage = 'Your phone number is not available please contact our customer support team.';
    },
    redirectToMobileNoPage() {
      this.$router.push({ name: "Mobile No", query: this.$route.query });
    },
    startTimer() {
      this.timerInterval = setInterval(() => {
        if (this.timer > 0) {
          this.timer -= 1;
        } else {
          clearInterval(this.timerInterval);
        }
      }, 1000);
    },
    customerOtp() {
      this.errorMessage = undefined;
      this.isSpinLoading = true;
      const params = {
        otp: this.otp.join(""),
        sessionId: this.sessionId,
        referrerCode: this.referrerCode
      };
      this.$store
        .dispatch("customerOtp", params)
        .then(() => {
          this.isSpinLoading = false;
          if (this.isReferralFlow) {
            this.$router.push({ name: "Signup" });
          } else if (this.$route.query.redirect) {
            this.$router.push({
              name: this.$route.query.redirect,
              query: this.$route.query
            });
          } else {
            this.$router.push({
              name: "Dashboard",
              query: this.$route.query
            });
          }
          this.homeFlags();
        })
        .catch(err => {
          this.errorMessage = err.message;
          this.isSpinLoading = false;
        });
    },
    resendOtp() {
      const params = {
        phone: this.$route.params.phone || this.phone,
        sessionId: this.sessionId
      };
      this.$store
        .dispatch("customerResendOtp", params)
        .then(() => {
          this.timer = 30;
          this.startTimer();
        })
        .catch(() => { });
    },
    isNumber(evt) {
      const event = evt || window.event;
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
      }
      return true;
    },
    handleInput(e) {
      const input = e.target;
      if (input.nextElementSibling && input.value) {
        input.nextElementSibling.focus();
      } else if (input.previousElementSibling && !input.value) {
        input.previousElementSibling.focus();
      }
    },
    handlePaste(e) {
      const paste = e.clipboardData.getData("text");
      const { form } = this.$refs;
      const inputs = form.querySelectorAll(".input");
      inputs.forEach((input, i) => {
        input.value = paste[i] || "";
      });
    },
    handleDeletion(e) {
      const FormElement = document.getElementsByTagName("input");
      const inputName = e.target.name;
      if (inputName === '2' && FormElement[0].value) {
        if (FormElement[1].value) {
          FormElement[1].focus();
        } else {
          FormElement[0].focus();
        }
      } else if (inputName === '3' && FormElement[1].value) {
        if (FormElement[2].value) {
          FormElement[2].focus();
        } else {
          FormElement[1].focus();
        }
      } else if (inputName === '4' && FormElement[2].value) {
        if (FormElement[3].value) {
          FormElement[3].focus();
        } else {
          FormElement[2].focus();
        }
      }
    },
    homeFlags() {
      this.isSpinLoading = true;
      this.$store.dispatch('homeFlags').then(() => {
        this.isSpinLoading = false;
      });
    },
    resetErrorMessageAndRedirectToGPay() {
      this.errorMessage = undefined;
      const urlParams = JSON.parse(localStorage.getItem("getURIParameter"));
      localStorage.setItem("newUrl", urlParams.href);
      this.logout();
    },
    logout() {
      this.$store.dispatch('customerLogout');
    },
    supportClicked() {
      this.$trackEvent(this.$mixpanelEvent.GPAY_MICRO_APP_SUPPORT_CLICKED, {
        [this.$mixpanelPayload.ERROR_REASON]: this.errorMessage,
      });
    }
  }
};
</script>
